import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=f363dad0"
import script from "./Wrapper.vue?vue&type=script&lang=js"
export * from "./Wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f363dad0')) {
      api.createRecord('f363dad0', component.options)
    } else {
      api.reload('f363dad0', component.options)
    }
    module.hot.accept("./Wrapper.vue?vue&type=template&id=f363dad0", function () {
      api.rerender('f363dad0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/dispenseManagement/Wrapper.vue"
export default component.exports